import { observer } from "mobx-react-lite";
import { FeatureGalleryGrid } from "../../../app/common/controls/FeatureGalleryGrid"; // generic layout
import { useNavigate } from "react-router-dom";
import {useStore} from "../../../app/stores/rootStore";
export default observer(function FeatureProductGalleryComponent({ title }) {
    const {newarrivalProductsStore} = useStore();
    const { products, productreload, loadProductList, setProductReload,setItem } = newarrivalProductsStore;
const navigate = useNavigate();
    return (
        <FeatureGalleryGrid
            title={title}
            items={products}
            isReloading={productreload}
            loadAction={loadProductList}
            setReloadAction={setProductReload}
            renderItem={(product) => (
                <div className="item features-image" key={product.id}>
                    <div className="item-wrapper">
                        <div className="item-img">
                            <div className="image-wrap">
                        {product.displayMode === "video" ? <video  controls autoPlay={true} loop muted>
        <source src={product.mainImageUrl} type="video/mp4" />
        Your browser does not support the video tag.
              </video> : <img src={product.mainImageUrl} alt={product.name} /> }
                        </div>
                        <div className="date-wrapper">
                            <p className="item-date mbr-fonts-style display-7"><strike>Rs. {product.productStrikePrice}<br/></strike>
                                <strong>Rs. {product.productPrice}</strong></p>
                        </div>
                        </div>
                        <div className="item-content">
                            <h4 className="item-title mbr-fonts-style display-7"><strong>{product.title} - {product.name}</strong></h4>
                            <p className="item-text mbr-fonts-style display-4">{product.description}</p><div class="mbr-section-btn">
                                <a onClick={()=>{
                            setItem(product);                                               
                            navigate(`/product/${product.id}`);
                        }} className="btn btn-primary-outline display-4">Buy Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        />
    );
});